import React from "react";
import { Icon } from "../../icons/icon";
import styled from "styled-components";
/**
 * 播放按钮
 *
 * @author 张卓诚
 * @export
 * @class IconPlay
 * @extends {React.PureComponent<IconPlayProps>}
 */
export class IconPlay extends React.PureComponent {
    constructor() {
        super(...arguments);
        /** 样式 */
        // tslint:disable: variable-name
        // tslint:disable-next-line: naming-convention
        this.ContainerStyle = styled.div `
    width: 100%;
    height: 100%;
    font-size: 20px;
    cursor: pointer;
    color: ${p => p.color};
    &:hover{
      color: ${p => p.hightLightColor};
    }
  `;
    }
    render() {
        const { iconInFalse, iconInTrue, color, highLightColor: hightLightColor, status } = this.props;
        const icon = status ? (React.createElement(this.ContainerStyle, { color: color, hightLightColor: hightLightColor, onClick: this.props.onClick },
            React.createElement(Icon, null, iconInTrue))) : (React.createElement(this.ContainerStyle, { color: color, hightLightColor: hightLightColor, onClick: this.props.onClick },
            React.createElement(Icon, null, iconInFalse)));
        return icon;
    }
}
//# sourceMappingURL=icon-play.js.map